// @flow
import React, { Suspense } from "react";
import type { UserData } from "../../common/types";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import ProfileTicket from "./ProfileTicket";
import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import moment from "moment";
import _ from "lodash";

type Props = {
  userData: UserData,
  userId: string,
};

const today = moment();

function ProfileTickets({ userData, userId }: Props) {
  const firestore = useFirestore();
  const gamesRef = firestore.collection("games");
  const games = useFirestoreCollectionData(gamesRef);

  if (
    userData.gameIdsWithTicketReservations == null ||
    userData.gameIdsWithTicketReservations.length < 1
  ) {
    return <NoUpcomingGames />;
  }

  const gameIdsByDateWithTicketReservations = userData.gameIdsWithTicketReservations.map(
    (gameIdWithTicketReservation) => {
      const game = games.find((g) => g.id === gameIdWithTicketReservation);
      if (game == null) {
        console.error("Game to ticketId was not found");
      }
      return {
        id: gameIdWithTicketReservation,
        dateMoment: moment(game.date),
        date: game.date,
      };
    }
  );

  const pastGameIds = _.orderBy(
    gameIdsByDateWithTicketReservations.filter((gameByDate) =>
      today.isAfter(gameByDate.dateMoment, "day")
    ),
    ["date", "asc"]
  );
  const futureGameIds = _.orderBy(
    gameIdsByDateWithTicketReservations.filter((gameByDate) =>
      today.isSameOrBefore(gameByDate.dateMoment, "day")
    ),
    ["date", "desc"]
  );

  return (
    <>
      {futureGameIds.length < 1 ? (
        <NoUpcomingGames />
      ) : (
        futureGameIds.map((gameIdsWithTicketReservation) => (
          <Suspense
            fallback={
              <Box mb={2}>
                <Skeleton variant="rect" width="100%" height={142} />
              </Box>
            }
            key={gameIdsWithTicketReservation.id}
          >
            <ProfileTicket
              gameId={gameIdsWithTicketReservation.id}
              userId={userId}
              userData={userData}
            />
          </Suspense>
        ))
      )}
      {pastGameIds.length > 0 && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Abgelaufene Tickets</Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{
              alignItems: "stretch",
              flexDirection: "column",
            }}
          >
            {pastGameIds.map((gameIdsWithTicketReservation) => {
              return (
                <Suspense
                  fallback={
                    <Box mb={2}>
                      <Skeleton variant="rect" width="100%" height={142} />
                    </Box>
                  }
                  key={gameIdsWithTicketReservation.id}
                >
                  <ProfileTicket
                    gameId={gameIdsWithTicketReservation.id}
                    userId={userId}
                    userData={userData}
                    disabled
                  />
                </Suspense>
              );
            })}
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
}

function NoUpcomingGames() {
  return (
    <Card>
      <CardContent>
        <Typography color="textSecondary">
          Du hast noch keine Tickets für kommende Spiele reserviert.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ProfileTickets;
